var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingRecollectPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41732 1.66699C4.26672 1.66699 3.33398 2.59973 3.33398 3.75033V16.2503C3.33398 17.4009 4.26672 18.3337 5.41732 18.3337H13.7507C14.9012 18.3337 15.834 17.4009 15.834 16.2503V7.3068C15.834 6.75426 15.6145 6.22436 15.2238 5.83366L11.6673 2.27719C11.2766 1.88649 10.7467 1.66699 10.1942 1.66699H5.41732Z",
    fill: "#F08E0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 14.1665C9.00804 14.1665 8.54167 13.7001 8.54167 13.1248L8.54167 9.38964L7.1949 10.7364C6.78811 11.1432 6.12856 11.1432 5.72176 10.7364C5.31497 10.3296 5.31497 9.67006 5.72176 9.26327L8.84676 6.13827C9.25356 5.73147 9.91311 5.73147 10.3199 6.13827L13.4449 9.26327C13.8517 9.67006 13.8517 10.3296 13.4449 10.7364C13.0381 11.1432 12.3786 11.1432 11.9718 10.7364L10.625 9.38964L10.625 13.1248C10.625 13.7001 10.1586 14.1665 9.58333 14.1665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingRecollectPending);
export default __webpack_public_path__ + "static/media/onboarding-recollect-pending.7d3f855db0676dabc28b4d9e758f52e7.svg";
export { ForwardRef as ReactComponent };